import React from 'react';

const KedmaCircleIcon = ({ size = 12, color = '#F68B28', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9311 5.88437C11.6793 3.23552 9.57012 1.12638 6.92127 0.874512V2.56388C8.6432 2.80033 10.0053 4.16245 10.2418 5.88437H11.9311ZM10.2418 6.95008C10.0053 8.67201 8.6432 10.0341 6.92127 10.2706V11.9599C9.57012 11.7081 11.6793 9.60065 11.9311 6.95179H10.2418V6.95008ZM5.85556 0.874512C3.20671 1.12638 1.09757 3.23552 0.845703 5.88437H2.53507C2.77152 4.16245 4.13364 2.80033 5.85556 2.56388V0.874512Z"
      fill={color}
    />
  </svg>
);

export default KedmaCircleIcon;